function initCustomerLogos() {
    /* Return if .partner-logos does not exist */
    if (!document.querySelector('.partner-logos')) {
        return;
    }

    // Get the list of partner logos and logo containers
    const partnerLogosContainer = document.querySelector('.partner-logos-for-list');
    const logoContainersList = document.querySelector('.logo-containers-list');
    const logoListItems = logoContainersList.querySelectorAll('li');

    // Get the images from the partner logos container
    const partnerLogos = partnerLogosContainer.querySelectorAll('.logo-container-inner');
    let currentIndex = 9;
    let randomIndex = 0;

    function fadeLogo(currentRandomIndex, direction) {
        let startingOpacity = direction === 1 ? 0 : 1;
        let endingOpacity = direction === 1 ? 1 : 0;

        const animationPromise = logoListItems[currentRandomIndex].animate(
            [{ opacity: startingOpacity }, { opacity: endingOpacity }], { duration: 1000 }
        ).finished;

        return animationPromise;
    }

    function getCurrentlyVisibleLogos() {
        const visibleLogos = [];

        logoListItems.forEach((item, index) => {
            item.querySelector('img').dataset.id === index && visibleLogos.push(index);
        });

        return visibleLogos;
    }

    // Define the function to perform the actions
    function updateLogo() {
        // Generate a random index for the logo container
        let newRandomIndex = Math.floor(Math.random() * logoListItems.length);
        let currentLogo = logoListItems[randomIndex].querySelector('.logo-container-inner').dataset.id;
        const visibleLogos = getCurrentlyVisibleLogos();

        // Make sure the random index is not the same as the previous one
        while (newRandomIndex === randomIndex || currentLogo === newRandomIndex || visibleLogos.includes(newRandomIndex)) {
            newRandomIndex = Math.floor(Math.random() * logoListItems.length);
        }

        randomIndex = newRandomIndex;

        // Fade out the current logo and wait for the animation to finish
        const fadeOutPromise = fadeLogo(randomIndex, -1);

        // Once the animation is finished, fade in the new logo

        fadeOutPromise.then(() => {
            // Clone the current image and append it to the random logo container
            const clonedImage = partnerLogos[currentIndex].cloneNode(true);

            logoListItems[randomIndex].innerHTML = ''; // Remove previous content
            logoListItems[randomIndex].appendChild(clonedImage);

            fadeLogo(randomIndex, 1);

            // Increment the current index and wrap around if needed
            currentIndex = (currentIndex + 1) % partnerLogos.length;

            // Wait for 4 seconds and then call the function again
            setTimeout(updateLogo, 2000);
        });
    }

    // Start the loop
    updateLogo();
}

export default initCustomerLogos;